import React from 'react';
import { RouteObject } from 'react-router-dom';
import { HomePage } from './views/HomePage';

export const routes: RouteObject[] = [
  { path: '', element: <HomePage /> },
];

export default routes;